
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FormattedMessage } from 'react-intl';

import './style.scss';
import { isEmpty } from 'lodash';

export enum MessageType {
  Success,
  Failure,
  Warning
}

interface IProps {
  type: MessageType;
  message: string;
  sessionId: string;
}

export function GeneralMessage(props: IProps) {

  const { type, message, sessionId } = props;
  
  const className = `messages-container ${type === MessageType.Success ? 'success' : type === MessageType.Failure ? 'failure' : 'warning'}`
  return (
    <div className={className} style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
      <span style={{ display: 'flex', alignItems: 'center' }}>
        <FontAwesomeIcon icon={faInfoCircle} />
        <FormattedMessage id={message} />
      </span>
      {!isEmpty(sessionId) && 
        <span style={{ textAlign: 'left', marginLeft: '24px', fontSize: '14px' }}>
          <FormattedMessage id="session.id" values={{ sessionId }} />
        </span>}
    </div>
  );
}
